import { Injectable } from '@angular/core'
import { SyncMainUnitDataDialogService } from './sync-main-unit-data-dialog.service'
import { ConfirmDialogService, Rental } from '@tokeet-frontend/tv3-platform'
import { switchMap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { SyncMainUnitData } from './sync-rental-data'

@Injectable({
  providedIn: 'root',
})
export class SyncMainUnitDataConfirmService {
  constructor(private confirmDialog: ConfirmDialogService, private syncDialog: SyncMainUnitDataDialogService) {}

  tryToSyncData(rental: Rental, data: SyncMainUnitData): Observable<any> {
    if (rental.id === rental.multi_unit_id) {
      return this.confirmDialog
        .confirm({
          title: $localize`Your Rental Has Been Updated – Apply to Subunits?`,
          body: $localize`Your rental has been updated. Do you want to apply this change to all subunits?`,
          cancelBtnClass: 'btn btn-secondary-light',
        })
        .pipe(switchMap(() => this.syncDialog.open(rental.id, data).afterClosed()))
    }
    return of(null)
  }

  confirmBeforeSave(rental: Rental): Observable<any> {
    if (rental.id !== rental.multi_unit_id) {
      return of(null)
    }
    return this.confirmDialog.confirm({
      title: $localize`Update Rental Settings?`,
      body: $localize`The settings will be applied to all subunit, Do you wish to continue?`,
      cancelBtnClass: 'btn btn-secondary-light',
    })
  }
}
